import de from '@/i18n/de.json'
import { type Composer, createI18n } from 'vue-i18n'
import type { NestedKeyOf } from '@/ts/types/utility.types.ts'
import { DEFAULT_LOCALE } from '@/ts/constants/constants.ts'
import validationI18nMessages, { type ValidationI18nSchemaTypes } from '@/libs/validation/i18n'
import { deepMerge } from '@/utils/data-utils'

type I18nSchemaTypes = typeof de & ValidationI18nSchemaTypes

export type I18nKeys = NestedKeyOf<I18nSchemaTypes> | (string & {})

export type SupportedLanguages = 'de'

export const i18nMessages: Record<SupportedLanguages, MessageSchema> = {
  de
}

type MessageSchema = typeof de

export function translate(key: I18nKeys, ...arg: string[]): string

export function translate(key: I18nKeys, obj: Record<string, string | number> | undefined): string

export function translate(key: I18nKeys, ...args: any[]): string {
  const { t } = i18n.global

  // object handling
  if (args.length === 1 && typeof args[0] === 'object') {
    return t(key, args[0])
  }

  return t(key, args)
}

function setupI18n() {
  const i18n = createI18n<false>({
    legacy: false,
    fallbackLocale: language(DEFAULT_LOCALE),
    globalInjection: true,
    warnHtmlMessage: false,
    fallbackWarn: true,
    missingWarn: true,
    messages: deepMerge(validationI18nMessages, i18nMessages)
  })
  setI18nLanguage(i18n.global, language(DEFAULT_LOCALE))
  return i18n
}

export const i18n = setupI18n()

export function setI18nLanguage(i18n: Composer, language: string) {
  i18n.locale.value = language
}

/**
 * Workaround because currently the API sends the i18n Translations with the language code instead of the locale
 * Expected: de-DE => de
 */
export function language(locale: string): string {
  return locale.split('-')[1].toLowerCase()
}
